import React from 'react'
import './index.scss'
import 'animate.css';
// {letterClassApply,arrayofCharacter,index }
function AnimatedLetters({letterClass,strArray,idx }) {
  return (
<span>
    {
 strArray.map((char,i) => (
  // char +1 
    <span key={i } className={`${letterClass} _${i + idx}`}>
        {char}
    </span>
))
    }
    
</span>
  )
}

export default AnimatedLetters
